import { useEffect, useState } from 'react';

/**
 * Whether `active` has held, without a break, for `ms` - and for the same `key`.
 *
 * A timer and not data: the one thing the conversation waits on that no frame
 * announces is a bubble that will never come (prolongation.md §4.6), and the
 * only way to know is to have waited. `key` re-arms it when what is awaited
 * changes (the next page), so a wait is never carried over to another page.
 */
export function useElapsed(active: boolean, key: string, ms: number): boolean {
  const [elapsedFor, setElapsedFor] = useState<string | null>(null);
  useEffect(() => {
    if (!active) {
      setElapsedFor(null);
      return;
    }
    const timer = window.setTimeout(() => setElapsedFor(key), ms);
    return () => window.clearTimeout(timer);
  }, [active, key, ms]);
  return active && elapsedFor === key;
}
